import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { useApp } from '../store';
export function NewsPage() {
  const {
    articles
  } = useApp();
  const [active, setActive] = useState('All');
  const categories = ['All', ...Array.from(new Set(articles.map(a => a.category)))];
  const filtered = active === 'All' ? articles : articles.filter(a => a.category === active);
  const [hero, ...rest] = filtered;
  return <>
      <PageHeader title="News" subtitle="Company updates, announcements, and stories." data-id="element-509" />

      {/* Category filter */}
      <div className="flex flex-wrap gap-2 mb-6" data-id="element-510">
        {categories.map(c => <button key={c} onClick={() => setActive(c)} className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${active === c ? 'bg-navy-600 text-white' : 'bg-white text-navy-600 border border-navy-100 hover:border-gold-400'}`} data-id="element-511">
            {c}
          </button>)}
      </div>

      {hero && <Link to={`/news/${hero.id}`} className="block group mb-8" data-id="element-512">
          <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} className="grid md:grid-cols-2 gap-6 bg-white rounded-2xl border border-navy-100 overflow-hidden" data-id="element-513">
            <div className="h-56 md:h-auto overflow-hidden" data-id="element-514">
              <img src={hero.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-515" />
            </div>
            <div className="p-6 flex flex-col justify-center" data-id="element-516">
              <div className="flex items-center gap-2 mb-2" data-id="element-517">
                <span className="text-xs font-bold uppercase tracking-widest text-gold-600" data-id="element-518">
                  {hero.category}
                </span>
                {hero.needsReview && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[0.65rem] font-bold uppercase tracking-wide bg-gold-50 text-gold-700 border border-gold-200" data-id="element-519">
                    <AlertTriangle className="w-3 h-3" data-id="element-520" /> Needs Review
                  </span>}
              </div>
              <h2 className="text-2xl font-serif font-bold text-navy-900 leading-tight mb-2 group-hover:text-gold-600 transition-colors" data-id="element-521">
                {hero.title}
              </h2>
              <p className="text-navy-600 text-sm leading-relaxed mb-4" data-id="element-522">
                {hero.excerpt}
              </p>
              <div className="flex items-center gap-2 text-xs text-navy-400" data-id="element-523">
                <img src={hero.authorAvatar} alt="" className="w-6 h-6 rounded-full" data-id="element-524" />
                <span className="font-medium text-navy-700" data-id="element-525">{hero.author}</span>
                <span data-id="element-526">·</span>
                <span data-id="element-527">{hero.date}</span>
                <span className="inline-flex items-center gap-1 ml-auto" data-id="element-528">
                  <Clock className="w-3 h-3" data-id="element-529" />
                  {hero.readTime}
                </span>
              </div>
            </div>
          </motion.div>
        </Link>}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-530">
        {rest.map((a, i) => <motion.div key={a.id} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} data-id="element-531">
            <Link to={`/news/${a.id}`} className="block group bg-white rounded-xl border border-navy-100 overflow-hidden h-full hover:shadow-md transition-shadow" data-id="element-532">
              <div className="h-40 overflow-hidden" data-id="element-533">
                <img src={a.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-534" />
              </div>
              <div className="p-4" data-id="element-535">
                <div className="flex items-center gap-2 mb-1" data-id="element-536">
                  <span className="text-[0.7rem] font-bold uppercase tracking-wide text-gold-600" data-id="element-537">
                    {a.category}
                  </span>
                  {a.needsReview && <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[0.6rem] font-bold uppercase tracking-wide bg-gold-50 text-gold-700 border border-gold-200" data-id="element-538">
                      <AlertTriangle className="w-3 h-3" data-id="element-539" /> Stale
                    </span>}
                </div>
                <h3 className="text-base font-serif font-bold text-navy-900 leading-snug mb-2 group-hover:text-gold-600 transition-colors" data-id="element-540">
                  {a.title}
                </h3>
                <div className="flex items-center gap-1.5 text-xs text-navy-400" data-id="element-541">
                  <span data-id="element-542">{a.date}</span>
                  <span data-id="element-543">·</span>
                  <span data-id="element-544">{a.readTime}</span>
                </div>
              </div>
            </Link>
          </motion.div>)}
      </div>
    </>;
}